// extracted by mini-css-extract-plugin
export default {"powerValueBannerContainer":"expected-power-value_powerValueBannerContainer__JJC2m"};